var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlovakia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40.0001C31.0459 40.0001 40.0002 31.0458 40.0002 20.0001C40.0002 8.95443 31.0459 0.00012207 20.0002 0.00012207C8.95449 0.00012207 0.000183105 8.95443 0.000183105 20.0001C0.000183105 31.0458 8.95449 40.0001 20.0002 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0456 40 20C40 17.5536 39.56 15.2101 38.756 13.0435H1.24401C0.440109 15.2101 3.05176e-05 17.5536 3.05176e-05 20C3.05176e-05 31.0456 8.9544 40 20 40Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C28.5993 40 35.9302 34.5725 38.7561 26.9565H1.24403C4.06989 34.5725 11.4008 40 20 40Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17184 11.3044V21.2815C5.17184 26.9568 12.586 28.6958 12.586 28.6958C12.586 28.6958 20.0001 26.9568 20.0001 21.2815V11.3044H5.17184Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91095 11.3044V21.2815C6.91095 21.9477 7.05892 22.5769 7.35204 23.1669H17.8198C18.1129 22.577 18.2609 21.9477 18.2609 21.2815V11.3044H6.91095Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0641 18.2609H13.4555V16.5217H15.1947V14.7826H13.4555V13.0435H11.7164V14.7826H9.97732V16.5217H11.7164V18.2609H9.10764V20H11.7164V21.7391H13.4555V20H16.0641V18.2609Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7244 25.5946C10.8451 26.2989 11.9965 26.7078 12.586 26.8897C13.1754 26.7079 14.3268 26.2989 15.4475 25.5946C16.5777 24.8843 17.3699 24.072 17.8198 23.1669C17.3236 22.8159 16.7182 22.6088 16.0642 22.6088C15.8261 22.6088 15.5948 22.637 15.3724 22.6888C14.901 21.6179 13.8311 20.8697 12.586 20.8697C11.341 20.8697 10.271 21.6179 9.79972 22.6888C9.57729 22.637 9.34589 22.6088 9.10784 22.6088C8.45386 22.6088 7.84847 22.8159 7.35229 23.1669C7.8019 24.0719 8.59417 24.8842 9.7244 25.5946Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovakia);
export default __webpack_public_path__ + "static/media/slovakia.a315bf1d2a037cea575f0d3f16d479c1.svg";
export { ForwardRef as ReactComponent };